import SwitcherInput from './SwitcherInput';

export default SwitcherInput;
